<template lang="pug">
#content.snap-content
  .overlay(@click="hide()")
  Marquee(:class="{ 'd-none': !whiteLabel }")
  toolBar
  .content-center.content-more(v-if="selectedMatchMore")
    .position-relative
      .morebet-wrapper
        .morebet-back
          a(href='javascript:void(0);' @click="back()")
            i.fas.fa-arrow-left
        .morebet-nav
          ul.nav.p-0.m-0
            template(v-if="marketKeys.length > 0")
              template(v-for="(ml, mk) in liveMarketKeys")
                template(v-if="ml == selectedMatchMore.categoryId")
                  template(v-for="(ll, lk) in marketList[selectedMatchMore.categoryId].leagueList")
                    template(v-if="ll.id == selectedMatchMore.groupId")
                      template(v-for="(mml, mmk) in ll.matchList")
                        moreTop(:source="mml" :index="mmk")
              template(v-for="(ml, mk) in todayMarketKeys")
                template(v-if="ml == selectedMatchMore.categoryId")
                  template(v-for="(ll, lk) in marketList[selectedMatchMore.categoryId].leagueList")
                    template(v-if="ll.id == selectedMatchMore.groupId")
                      template(v-for="(mml, mmk) in ll.matchList")
                        moreTop(:source="mml" :index="mmk")
              template(v-for="(ml, mk) in earlyMarketKeys")
                template(v-if="ml == selectedMatchMore.categoryId")
                  template(v-for="(ll, lk) in marketList[selectedMatchMore.categoryId].leagueList")
                    template(v-if="ll.id == selectedMatchMore.groupId")
                      template(v-for="(mml, mmk) in ll.matchList")
                        moreTop(:source="mml" :index="mmk")
            template(v-if="marketKeys.length > 0")
              li.dropdown.select-league-dropdown
                #dropdownMenuButton.btn-select-league.dropdown-toggle(@click="toggleDropdown()" aria-expanded="false")
      .tab-content
        .tab-pane.fade.show.active
          .more-market-content(:class="{ 'is-live' : selectedMatchMore ? selectedMatchMore.marketId == 3 : false }")
            template(v-if="selectedMatchMore != null && (selectedMatchMore.channelId || selectedMatchMore.radarId)")
              div
                ul.m-0.p-0.match-detail-function-tab
                  li(v-if="selectedMatchMore.channelId")
                    a.nav-link(:class="{ 'active': mode == 0 }" @click="setMode(0)")
                      .icon-function
                        img(:src="(source.marketId == 3) ? '/images/live-stream-live.svg?v=12' : '/images/live-stream.svg?v=12'")
              #live-widget.live-center
                i(v-if="loader").fa.fa-spinner.fa-spin
                span(v-else) {{ error }}
                #live-widget-iframe
              #live-widget-btn.screen-btn.show(@click="toggleWidget()")
            moreContentX(
              v-if="selectedMatchMore"
              :source="selectedMatchMore"
              :child1Ids="selectedMatchMore.details.child1"
              :child2Ids="selectedMatchMore.details.child2"
              @popup-livetv="stopMainLiveTV"
            )
    #dropdown-select-league.dropdown-menu.dropdown-select-league
      template(v-for="(ml, mk) in liveMarketKeys")
        template(v-for="(ll, lk) in marketList[ml].leagueList")
          a.dropdown-item.live(href="javascript:void(0);" @click="setLeague(ll)")
            span.icon
              img(:src="'/images/icon-sport-svg/' + getSportsImage(ll.sportsId)")
              img.live-icon(src='/images/live.svg?v=12')
            | {{ ll.leagueName }}
      template(v-for="(ml, mk) in todayMarketKeys")
        template(v-for="(ll, lk) in marketList[ml].leagueList")
          a.dropdown-item(href="javascript:void(0);" @click="setLeague(ll)")
            span.icon
              img(:src="'/images/icon-sport-svg/' + getSportsImage(ll.sportsId)")
            | {{ ll.leagueName }}
      template(v-for="(ml, mk) in earlyMarketKeys")
        template(v-for="(ll, lk) in marketList[ml].leagueList")
          a.dropdown-item(href="javascript:void(0);" @click="setLeague(ll)")
            span.icon
              img(:src="'/images/icon-sport-svg/' + getSportsImage(ll.sportsId)")
            | {{ ll.leagueName }}
      //- a.dropdown-item(@click="toggleDropdown()").text-center
      //-   i.fa.fa-chevron-up
  template(v-else)
    .preloader
      .loader
  footerNav
</template>

<script>
import toolBar from "@/components/mobile/toolBar";
import footerNav from "@/components/mobile/footerNav";
import config from "@/config";
import errors from "@/errors";
import xhr from "@/library/_xhr-game.js";
import { EventBus } from "@/library/_event-bus.js";
import mixinMain from "@/library/mixinMain.js";
import mixinExt from "@/library/mixinExt.js";
import moreTop from "@/components/mobile/main/more/moreTop";
import moreContentX from "@/components/mobile/main/more/moreContentX";
import Marquee from "@/components/mobile/mainPanelControl/marquee";

export default {
  components: {
    toolBar,
    footerNav,
    moreTop,
    moreContentX,
    Marquee
  },
  mixins: [mixinMain, mixinExt],
  data() {
    return {
      mode: 0,
      error: null,
      url: "",
      embedded: false,
      loader: false
    };
  },
  computed: {
    whiteLabel() {
      // return this.$store.getters.whiteLabel;
      return config.whiteLabel == "1";
    },
    asidebar() {
      return this.$store.getters.minimizer.asidebar;
    },
    radarId() {
      return this.$store.state.layout.radarId;
    },
    channel() {
      return this.$store.state.layout.channel;
    },
    selectedMatchMore() {
      return this.matchList[this.selectedMatch];
    },
    newFeatures() {
      return config.newFeatures;
    }
  },
  destroyed() {
    EventBus.$off("MARKET_NODATA", this.back);
    EventBus.$off("MARKET_DONE", this.verifySelectedMatch);
  },
  mounted() {
    EventBus.$on("MARKET_NODATA", this.back);
    EventBus.$on("MARKET_DONE", this.verifySelectedMatch);
    EventBus.$on("INVALIDATE", this.runInvalidate);
    this.autoPlay(this.$route.params.mode);
  },
  methods: {
    hide(e) {
      var body = $("body");
      if (body.hasClass("snapjs-left")) {
        body.removeClass("snapjs-left");
      }
    },
    toggleDropdown() {
      var expand = $("#dropdownMenuButton").attr("aria-expanded");
      if (expand == "true") {
        $("#dropdownMenuButton").attr("aria-expanded", "false");
        $("#dropdown-select-league").hide();
      } else {
        $("#dropdownMenuButton").attr("aria-expanded", "true");
        $("#dropdown-select-league").show();
      }
    },
    runInvalidate() {
      this.autoPlay(this.$route.params.mode);
    },
    setLeague(e) {
      if (e != null && e.matchList != null && e.matchList.length > 0) {
        this.$store.dispatch("layout/setSelectedMatch", e.matchList[0].matchId);
        EventBus.$emit("INVALIDATE");
      } else {
        this.back();
      }
    },
    verifySelectedMatch() {
      var a = Object.keys(this.matchList);
      if (!a.includes(this.selectedMatch.toString())) {
        this.back();
      }
    },
    autoPlay(e) {
      if (this.selectedMatchMore == null) {
        setTimeout(() => {
          this.autoPlay(e);
        }, 1000);
      } else {
        if (this.selectedMatchMore.channelId) {
          if (this.selectedMatchMore.marketId == 3) {
            if (e != null) {
              this.mode = e;
            } else {
              this.mode = 0;
            }
          } else {
            this.mode = 0;
            // if (this.selectedMatchMore.radarId > 0) {
            //   this.mode = 1;
            // } else {
            //   this.mode = 0;
            // }

            // if (this.selectedMatchMore.stats > 0) {
            //   this.mode = 2;
            // } else if (this.selectedMatchMore.radarId > 0) {
            //   this.mode = 1;
            // } else {
            //   this.mode = 0;
            // }
          }
        } else {
          this.mode = 0;
        }
        this.openWidget();
      }
    },
    getSportsImage(e) {
      return config.getSportsImage(e);
    },
    toggleWidget(e) {
      $("#live-widget").slideToggle();
      $("#live-widget-btn").toggleClass("show");
    },
    collapseWidget() {
      $("#live-widget").slideUp();
      $("#live-widget-btn").removeClass("show");
    },
    expandWidget() {
      $("#live-widget").slideDown();
      $("#live-widget-btn").addClass("show");
    },
    back() {
      this.$store.dispatch("layout/resetSelectLeague");
      this.$store.dispatch("layout/setSelectedMatch", null);
      setTimeout(() => {
        this.$router.push("/prematch").catch(err => {});
      }, 500);
    },
    moreLeagues(event) {
      event.stopPropagation();
      $(".dropdown-select-league").slideToggle();
      $(".btn-select-league").toggleClass("active");
      $(".morebet-nav").toggleClass("open-more-league");
    },
    openWidget() {
      this.resizeWidget(this.mode);
      switch (this.mode) {
        case 0:
          $(".live-center").removeClass("dark");
          this.error = "";
          if (this.selectedMatchMore != null && this.selectedMatchMore.channelId != null && this.selectedMatchMore.channelId > 0 && this.selectedMatchMore.marketId == 3 && this.selectedMatchMore.sportsId != null) {
            this.openLiveMatch();
            this.expandWidget();
          } else {
            this.closeWidget();
          }
          break;
        case 1:
          $(".live-center").addClass("dark");
          this.error = "";
          if (this.selectedMatchMore != null && this.selectedMatchMore.radarId != null) {
            this.openLiveTracker();
            this.expandWidget();
          } else {
            this.closeWidget();
          }
          break;
        case 2:
          $(".live-center").addClass("dark");
          this.error = "";
          if (this.selectedMatchMore != null && this.selectedMatchMore.stats != null) {
            this.xLinkStats();
            this.expandWidget();
          } else {
            this.closeWidget();
          }
          break;
      }
    },
    closeWidget(e) {
      this.setWidget("");
      this.error = this.$t("message.match_not_started");
      var elem = $("#live-widget-btn");
      if (elem.hasClass("show")) {
        this.collapseWidget();
      }
    },
    stopMainLiveTV() {
      this.loader = false;
      this.setWidget("");
      this.error = "";
      this.collapseWidget();
    },
    setWidget(e) {
      $("#live-widget-iframe").html(e);
    },
    switchWidget(e) {
      this.setWidget("");
      this.error = this.$t("message.match_not_started");
      this.resizeWidget(e);
      switch (e) {
        case 0:
          $(".live-center").removeClass("dark");
          this.error = "";
          if (this.selectedMatchMore != null && this.selectedMatchMore.channelId != null && this.selectedMatchMore.channelId > 0 && this.selectedMatchMore.marketId == 3 && this.selectedMatchMore.sportsId != null) {
            this.openLiveMatch();
            this.expandWidget();
          } else {
            this.closeWidget();
          }
          break;
        case 1:
          $(".live-center").addClass("dark");
          this.error = "";
          if (this.selectedMatchMore != null && this.selectedMatchMore.radarId != null) {
            this.openLiveTracker();
            this.expandWidget();
          } else {
            this.closeWidget();
          }
          break;
        case 2:
          $(".live-center").addClass("dark");
          this.error = "";
          if (this.selectedMatchMore != null && this.selectedMatchMore.stats != null) {
            this.xLinkStats();
            this.expandWidget();
          } else {
            this.closeWidget();
          }
          break;
      }
    },
    setMode(e) {
      this.mode = e;
      this.switchWidget(e);
    },
    openLiveMatch() {
      if (this.selectedMatchMore != null && this.selectedMatchMore.channelId != null && this.selectedMatchMore.channelId > 0 && this.selectedMatchMore.marketId == 3 && this.selectedMatchMore.sportsId != null) {
        if (this.selectedMatch.channelId == "1") {
          this.launchLiveTV(this.selectedMatchMore.channelId, this.selectedMatchMore.matchId, this.selectedMatchMore.sportsId, "1.1.1.1");
        } else {
          this.getVersion().then(
            res => {
              let ip = res;
              this.launchLiveTV(this.selectedMatchMore.channelId, this.selectedMatchMore.matchId, this.selectedMatchMore.sportsId, ip);
            },
            err => {
              this.error = err;
            }
          );
        }
      } else {
        this.closeWidget();
      }
    },
    xLinkStats(e) {
      if (this.selectedMatchMore && this.selectedMatchMore.stats) {
        var url = config.statscenterUrl() + this.selectedMatchMore.stats + "&u=" + this.$store.getters.accountId + "&t=" + this.$store.getters.sessionToken + "&l=" + this.$store.getters.language;
        // window.open(url, "stats", "top=10,height=540,width=900,status=no,toolbar=no,menubar=no,location=no");
        var html = '<iframe src="' + url + '" frameborder="0" allowfullscreen="true" scrolling="no">';
        this.setWidget(html);
      }
      return false;
    },
    resizeWidget(e) {
      var r1 = 234 / 414;
      if (e == 1) {
        r1 = 322 / 414;
      }
      var e1 = $("#live-widget");
      e1.height(e1.width() * r1);
    },
    launchLiveTV(ch, mc, sp, ip) {
      var args = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        channel: ch,
        match: mc,
        sports: sp,
        ip: ip
      };
      this.loader = true;
      this.error = "";
      xhr.launchLiveTV(args).then(
        res => {
          this.loader = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              this.embedded = this.url.includes("<iframe");
              if (!this.embedded) {
                this.embedded = this.url.includes("<script");
              }

              if (!this.embedded) {
                // not a iframe link, can be glive or self-hosted live streaming
                //
                if (ch != 1) {
                  var link = this.url + "&compact=1";
                  var html = '<iframe src="' + link + '" frameborder="0" allowfullscreen="true" scrolling="no">';
                  this.setWidget(html);
                } else {
                  // var link = config.bintuUrl() + this.url + "&u=" + args.account_id + "&t=" + args.session_token;
                  var link = this.tvLink(sp) + this.url + "&u=" + args.account_id + "&t=" + args.session_token + "&product=" + sp;
                  var html = '<iframe src="' + link + '" frameborder="0" allowfullscreen="true" scrolling="no">';
                  this.setWidget(html);
                }
              } else {
                // is a iframe link, can be twitch, youtube or any embeded video
                var kns = this.url.replace("www.example.com", window.location.hostname);
                this.setWidget(kns);
              }
            } else {
              this.error = this.$t("error." + res.status);
            }
          }
        },
        err => {
          console.log(err);
          this.loader = false;
          this.error = this.$t("error." + err.status);
        }
      );
    },
    tvLink(e) {
      if (config.vg1.includes(e)) {
        return config.player10Url();
      } else {
        return config.bintuUrl();
      }
    },
    getVersion(q) {
      const url = "https://api.ipify88.com/";
      const feedback = {
        success: false,
        status: errors.login.failed
      };
      return new Promise((resolve, reject) => {
        this.$http.get(url).then(
          res => {
            resolve(res.bodyText);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    openLiveTracker() {
      if (this.selectedMatchMore.radarId) {
        var url = config.radarUrl() + this.selectedMatchMore.radarId + "&u=" + this.$store.getters.accountId + "&t=" + this.$store.getters.sessionToken;
        var html = '<iframe src="' + url + '" frameborder="0" allowfullscreen="true" scrolling="no">';
        this.setWidget(html);
      }
    }
  }
};
</script>
